import { GlAvatar } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import SafeHtml from '~/vue_shared/directives/safe_html';
import NoteHeader from '/builds/gitlab/gitlab-ee/app/assets/javascripts/notes/components/note_header.vue?vue3';
import TimelineEntryItem from '~/vue_shared/components/notes/timeline_entry_item.vue';
export default {
    name: 'WorkItemNoteReplying',
    components: {
        TimelineEntryItem,
        GlAvatar,
        NoteHeader
    },
    directives: {
        SafeHtml
    },
    safeHtmlConfig: {
        ADD_TAGS: [
            'use',
            'gl-emoji',
            'copy-code'
        ]
    },
    constantOptions: {
        avatarUrl: window.gon.current_user_avatar_url
    },
    props: {
        body: {
            type: String,
            required: false,
            default: ''
        },
        isInternalNote: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        author () {
            return {
                avatarUrl: window.gon.current_user_avatar_url,
                id: window.gon.current_user_id,
                name: window.gon.current_user_fullname,
                username: window.gon.current_username
            };
        },
        entryClass () {
            return {
                'note note-wrapper note-comment being-posted': true,
                'internal-note': this.isInternalNote
            };
        }
    }
};
